<template lang="pug">
v-navigation-drawer(v-model="drawer" app)
  v-img.ma-4(
    src="../assets/logo-colored.svg"
    position="left center"
    alt="Imagem da Logo"
    contain
    height=24
    @click="$router.push('/')"
  )
  v-divider
  v-list(nav)
    v-list-item(
      v-for="item of items"
      :key="item.title"
      color="primary"
      :to="item.to"
    )
      v-list-item-content
        v-list-item-title {{ item.title }}
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  data() {
    return {
      items: [
        {
          title: 'para você',
          to: '/'
        },
        {
          title: 'para empresas',
          to: '/empresa'
        },
        {
          title: 'planos',
          to: '/planos'
        },
        {
          title: 'contato',
          to: '/contato'
        }
      ]
    }
  },
  computed: {
    ...mapFields('page', ['drawer'])
  }
}
</script>

<style lang="scss"></style>
